module.exports = __webpack_public_path__ + "images/star_yellow75d8740efffb835ec5b239e0480e2388.png";